module.exports = {
    login:'ログイン',
    taption: 'Taption',
    ways_to_use_taption:'簡単な教え',
    faq:'よくある問題',
    pricing:'価格',
    language:'言語',
    product:'製品説明'
  }
  